import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Avatar from "module-common/Avatar";

export default class Row extends Component {
  static propTypes = {
    displayPicture: PropTypes.string,
    displayName: PropTypes.string,
    status: PropTypes.string
  };

  render() {
    const { displayPicture, displayName, status } = this.props;
    return (
      <Wrapper>
        <Avatar isSmall image={displayPicture} status={status} />
        <Name offline={status.toLowerCase() === "offline"}>{displayName}</Name>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: none;
  height: 50px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  padding: 0 14px;
  align-items: center;
`;
const Name = styled.div`
  margin-left: 14px;
  font-weight: bold;
  ${props => props.offline && "font-style: italic;color: #9c9c9c;"};
`;



// WEBPACK FOOTER //
// ./src/module-sidemenu/online-status/Row.js